import {
  LocationHours,
  TemporaryHours,
} from 'api/ordering-service/ordering-service.types';

export const transformHoursForRequest = (
  hours: LocationHours[],
): LocationHours[] => {
  if (!hours) return hours;

  return hours.map(hour => ({
    ...hour,
    timeSlots: hour.timeSlots.map(slot => ({
      ...slot,
      endTime: slot.endTime === '00:00:00' ? '23:59:59' : slot.endTime,
    })),
  }));
};

export const transformTemporaryHoursForRequest = (
  temporaryHours: TemporaryHours[],
): TemporaryHours[] => {
  if (!temporaryHours) return temporaryHours;

  return temporaryHours.map(hour => ({
    ...hour,
    sameHoursPerDate: hour.sameHoursPerDate
      ? {
          ...hour.sameHoursPerDate,
          timeSlots: hour.sameHoursPerDate.timeSlots
            ? hour.sameHoursPerDate.timeSlots.map(slot => ({
                ...slot,
                endTime:
                  slot.endTime === '00:00:00' ? '23:59:59' : slot.endTime,
              }))
            : [],
        }
      : hour.sameHoursPerDate,
    diffHoursPerDate:
      hour.diffHoursPerDate && Object.keys(hour.diffHoursPerDate).length
        ? hour.diffHoursPerDate
        : null,
  }));
};
